module.exports = __webpack_public_path__ + "img/SixtoGo.8a696c4e.png";